import { HasViewInstanceId } from './types';

export const hasViewInstanceId = (
  viewProperties: Record<string, unknown>
): viewProperties is HasViewInstanceId =>
  typeof viewProperties.viewInstanceId === 'string';
